import { Component, ElementRef, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';


import { MatButtonModule } from '@angular/material/button';

// Services
import { ControllerService } from '../../../services/controller/controller.service';
import { LanguageService } from '../../../services/language/language.service';

// Papers
import { Papers } from '../../../constants/paper-list';

@Component({
  selector: 'app-software',
  standalone: true,
  imports: [
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './software.component.html',
  styleUrl: './software.component.css'
})
export class SoftwareComponent {

  @ViewChild('videoElement') videoElement!: ElementRef;


  ItemList_parpers:any = Papers

  /* 
  Se ha marcado el servicio "controllerService" como "readonly", porque se inyecta en el 
  constructor y no se vuelve a modificar. Esto es una buena práctica.
  */
  constructor(
    private readonly controllerService:ControllerService,
    public languageService:LanguageService,
  ) { }



  ngOnInit(): void {
    // Scroll to the top every time the page is loaded
    window.scrollTo(0,0)
  }



  navigate(route:string){
    this.controllerService.navigate(route)
  }


  
  itemClicked(item:any){
    window.open(item.doi, "_blank");
  }
  
  onItemKeyDown(event: KeyboardEvent, item: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.itemClicked(item);
    }
  }  

}
